<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousPage" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Sail & FPOD</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-2">
              <!-- <b-button
                size="sm"
                variant="outline-info"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
              >Hide Details</b-button> -->
              <!-- <b-collapse id="collapse-4" v-model="visible" class="mt-2">
                 <b-card  class="HeaderMastBanner">
                  <md-layout gutter>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <b>
                          Client Name : {{mainEntryData[0].clientName}}
                          <br>
                        </b>
                        <b>Assignment No. : {{mainEntryData[0].ffExportFclSeries}}</b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <b>Stuffing Type : {{mainEntryData[0].stuffingType}}</b>
                        <br>
                        <b>FF Activity : {{mainEntryData[0].containerInfo}}</b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="40">
                      <md-layout md-flex="100">
                        <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </b-card>
              </b-collapse> -->
            </div>
          
            <div class="phone-viewport" id="vehicleBooking">
              <md-list>
                <md-list-item
                    style="background:darkcyan !important"
                  id="showvehicleBooking"
                  class="md-button-color-toggle"
                  v-bind:class="getContainerSail.length>0?'md-active':''"
                >
                  <span style="color:white">Sail Details</span>

                  <md-list-expand>
                    <md-list>
                      <div v-if="getContainerSail.length>0 || sailVModel.ffSailId!=''">
                        <md-layout gutter class="labelMargtop">
                         
                          <md-layout md-flex="40">
                            <label for="isBookingtranshipment">Booking transhipment *</label>
                            <model-list-select
                              :list="bookingtranshipmentList"
                              v-model="sailVModel.isBookingtranshipment"
                              :isDisabled="tentativeDetailArrayList.length>0?true:false"
                              option-value="bookingtranshipmentVal"
                              option-text="bookingtranshipmentText"
                              placeholder="Select Booking transhipment"
                            ></model-list-select>
                            <span
                              class="error"
                              v-if="!sailVModel.isBookingtranshipment"
                            >{{SailerrorList.isBookingtranshipment}}</span>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="55">
                            <label
                              for="shippingId"
                              v-if="sailVModel.ffSailId==''"
                            >Container Number *</label>
                            <model-list-select
                              v-if="sailVModel.ffSailId==''"
                              :list="containerSailList"
                              v-model="sailVModel.ffExecutionContainerId"
                              option-value="ffExecutionContainerId"
                              option-text="containerNo"
                              placeholder="Select Container Number"
                            ></model-list-select>
                            <md-layout md-flex="100" v-else>
                              <label for="shippingId">Container Number *</label>
                              <b-form-input :formatter="capitalizeAll" disabled v-model="sailVModel.containerNo"></b-form-input>
                            </md-layout>
                            <span
                              class="error"
                              v-if="!sailVModel.containerNo"
                            >{{SailerrorList.containerNo}}</span>
                          </md-layout>
                        </md-layout>
<b-card class="mt-3" style="background:whitesmoke">
 <div >
                <h5>
                  <b-badge>SOB Details</b-badge>
                </h5>
              </div>
                        <md-layout gutter class="labelMargtop">
                       
                          <md-layout md-flex="40">
                            <md-layout md-flex="100">
                              <label>Vessel Name</label>
                              <b-form-input :formatter="capitalizeAll"
                                id="vesselName"
                                name="vesselName"
                                v-model="sailVModel.vesselName"
                              ></b-form-input>
                            </md-layout>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="55">
                            <md-layout md-flex="100">
                              <label>Voyage Name</label>
                              <b-form-input :formatter="capitalizeAll"
                                id="voyageName"
                                name="voyageName"
                                v-model="sailVModel.voyageName"
                              ></b-form-input>
                            </md-layout>
                          </md-layout>
                          <!-- <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="20">
                            <md-layout md-flex="100">
                              <label>Rotation No.</label>
                              <b-form-input :formatter="capitalizeAll"
                                id="rotationNo"
                                name="rotationNo"
                                v-model="sailVModel.rotationNo"
                              ></b-form-input>
                            </md-layout>
                          </md-layout>-->
                        </md-layout>
</b-card>
                        <div class="gutr mt-3" v-if="sailVModel.isBookingtranshipment=='yes'">
                       <b-card>
                            <md-layout md-gutter v-if="sailVModel.isBookingtranshipment=='yes'">
                            
                              <h5>
                                <b-badge>
                                  Transhipment Details
                                  <span
                                    v-if="tentativeDetailArray.length==0"
                                    class="error"
                                  >{{atleastOneTentative}}</span>
                                </b-badge>
                              </h5>
                            </md-layout>

                            <md-layout
                              md-gutter
                              class="labelMargtop"
                              v-if="sailVModel.isBookingtranshipment=='yes'"
                            >
                             
                              <md-layout md-flex="40">
                                <label for="tentativePortId">Tentative Port Name *</label>
                                <model-list-select
                                  @input="getLocationList($event,'Sea_Port','getlocationListData')"
                                  @searchchange="getLocationList($event,'Sea_Port','getlocationListData')"
                                  option-value="pickupId"
                                  option-text="pickupLocation"
                                  :list="getlocationListData"
                                  placeholder="Select Port Name"
                                  v-model="transhipment.tentativePortId"
                                ></model-list-select>
                                <span
                                  class="error"
                                  v-if="!transhipment.etdTime"
                                >{{TranshiperrorList.tentativePortId}}</span>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="15">
                                <label>ETA Date *</label>

                                <date-picker
                                  lang="en"
                                  v-model="transhipment.etaDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm "
                                  :minute-step="1"
                                  id="etaDate"
                                ></date-picker>
                                <span
                                  class="error"
                                  v-if="!transhipment.etdTime"
                                >{{TranshiperrorList.etdTime}}</span>
                              </md-layout>

                              <md-layout md-flex="5"></md-layout>

                              <md-layout md-flex="15">
                                <label>ETD Date *</label>
                                <date-picker
                                  lang="en"
                                  v-model="transhipment.etdDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm "
                                  :minute-step="1"
                                  id="etdDate"
                                ></date-picker>
                                <span
                                  class="error"
                                  v-if="!transhipment.etdTime"
                                >{{TranshiperrorList.etdTime}}</span>
                              </md-layout>
                            </md-layout>

                            <md-layout
                              md-gutter
                              class="labelMargtop"
                              v-if="sailVModel.isBookingtranshipment=='yes'"
                            >
                         
                              <md-layout md-flex="40">
                                <md-layout md-flex="100">
                                  <label>Vessel Name</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="transvesselName"
                                    name="transvesselName"
                                    v-model="transhipment.vesselName"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="35">
                                <md-layout md-flex="100">
                                  <label>Container No</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="transcontainerNo"
                                    name="transcontainerNo"
                                    v-model="transhipment.containerNo"
                                    disabled
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="15" style="margin-top:40px">
                                <b-button
                                  variant="info"
                                  size="sm"
                                  @click="addTentativeDetail"
                                  id="addButtonLoader222"
                                >{{editIndex=='' && (editIndex!='0' || editIndex!=0) && transhipment.sailTranshipmentId==''?"Add":"Update" }} Transhipment</b-button>

                                <md-spinner md-indeterminate id="loader222" style="display:none"></md-spinner>
                              </md-layout>
                            </md-layout>

                            <div class=" mt-3" v-if="tentativeDetailArrayList.length>0">
                             

                              <!-- /.box-header -->
                              <div class="box-body">
                                <table id="poTablefdfdf" class="table table-bordered ">
                                  <thead>
                                    <tr>
                                      <th>Sr No.</th>
                                      <th>Tentative Port Name</th>
                                      <th>Arrival Time</th>
                                      <th>Departure Time</th>
                                      <th>Edit</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(item,index) in tentativeDetailArrayList"
                                      :key="index"
                                    >
                                      <td>{{index+1}}</td>
                                      <td>{{item.tentativePortName}}</td>
                                      <td>{{item.etaDate}}</td>
                                      <td>{{item.etdDate}}</td>

                                      <td>
                                        <md-button
                                          class="md-icon-button md-raised md-dense"
                                          @click="viewEdit(item.sailTranshipmentId,index)"
                                        >
                                          <md-icon>edit</md-icon>
                                        </md-button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <!-- /.box-body -->
                            </div>
                       </b-card>
                        </div>

                        <md-layout gutter class="labelMargtop">
                        
                          <md-layout md-flex="15">
                            <label>Loading Vessel Date</label>

                            <date-picker
                              lang="en"
                              v-model="sailVModel.vesselLoadingDate"
                              type="date"
                              :format="selectDateFormat"
                              id="vesselLoadingDate"
                              :minute-step="1"
                            ></date-picker>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="15">
                            <label>Departure Date</label>

                            <date-picker
                              lang="en"
                              v-model="sailVModel.dateOfDeparture"
                              type="date"
                              :format="selectDateFormat"
                              id="dateOfDeparture"
                              :minute-step="1"
                            ></date-picker>
                          </md-layout>
                          <md-layout md-flex="10"></md-layout>
                          <md-layout md-flex="20">
                            <label>Arrival Date at Delivery Port</label>
                            <date-picker
                              lang="en"
                              v-model="sailVModel.deliveryPortArrDate"
                              type="date"
                              :format="selectDateFormat"
                              id="deliveryPortArrDate"
                              :minute-step="1"
                            ></date-picker>
                          </md-layout>
                        </md-layout>

                        <md-layout gutter class="labelMargtop"></md-layout>

                        <md-layout md-gutter class="mrgtop-button">
                         
                          <md-layout md-flex="20">
                            <b-button
                            class="mt-3"
                              variant="primary"
                              id="addButtonLoader1"
                              @click="addSail"
                            >Save & Submit</b-button>
                            <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
                          </md-layout>
                        </md-layout>
                      </div>

                      <div class="mt-3" v-if="viewAllSailList.length>0">
                        <h5 >
                          <b-badge >Sail Details</b-badge>
                        </h5>

                        <!-- /.box-header -->
                        <div class="box-body">
                          <table id="sailAll" class="table table-bordered ">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>Container No</th>
                                <th>Vessel Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item,index) in viewAllSailList" :key="index">
                                <td>{{index+1}}</td>
                                <td
                                  @click="viewEditSail(item)"
                                  class="showMoreData"
                                >{{item.containerNo}}</td>
                                <td>{{item.vesselName}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!-- /.box-body -->
                      </div>
                    </md-list>
                  </md-list-expand>
                </md-list-item>
              </md-list>
            </div>

            <div class="phone-viewport" id="vehicleBooking" v-if="getContainerSail.length==0">
              <md-list>
                <md-list-item
                  style="background:darkcyan !important"
                  id="showvehicleBooking"
                  class="md-button-color-toggle md-active"
                >
                  <span style="color:white">FINAL DELIVERY DETAILS for FF Assignment Closure</span>

                  <md-list-expand>
                    <md-list>
                      <div
                        v-if="containerNoFPODList.length>0 || finalDeliveryModel.fffpodContainerId!=''"
                      >
                        <md-layout md-gutter class="labelMargtop">
                         

                          <md-layout md-flex="45">
                            <label
                              for="containerNo"
                              v-if="finalDeliveryModel.fffpodContainerId==''"
                            >Container No *</label>
                            <model-list-select
                              v-if="finalDeliveryModel.fffpodContainerId==''"
                              :list="containerNoFPODList"
                              v-model="finalDeliveryModel.ffExecutionContainerId"
                              option-value="ffExecutionContainerId"
                              option-text="containerNo"
                              placeholder="Select Container No"
                            ></model-list-select>
                            <md-layout md-flex="100" v-else>
                              <label for="containerNo">Container No *</label>
                              <b-form-input :formatter="capitalizeAll" v-model="finalDeliveryModel.containerNo" disabled></b-form-input>
                            </md-layout>
                            <span
                              class="error"
                              v-if="!finalDeliveryModel.containerNo"
                            >{{FPODerrorList.containerNo}}</span>
                          </md-layout>
                        </md-layout>
                        <md-layout md-gutter class="labelMargtop">
                        
                          <md-layout md-flex="45">
                            <label for="podLocationId">POD Location *</label>
                            <model-list-select
                              @input="getLocationList($event,'Sea_Port','PODlocationList')"
                              @searchchange="getLocationList($event,'Sea_Port','PODlocationList')"
                              option-value="pickupId"
                              option-text="pickupLocation"
                              :list="PODlocationList"
                              placeholder="Select POD Location"
                              v-model="finalDeliveryModel.podLocationId"
                            ></model-list-select>
                            <span
                              class="error"
                              v-if="!finalDeliveryModel.podLocationId"
                            >{{FPODerrorList.podLocationId}}</span>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="50">
                            <label for="FpodLocationId">FPOD Location *</label>
                            <model-list-select
                              @input="getLocationList($event,'Sea_Port','FPODpickupLocation')"
                              @searchchange="getLocationList($event,'Sea_Port','FPODpickupLocation')"
                              option-value="pickupId"
                              option-text="pickupLocation"
                              :list="FPODpickupLocation"
                              placeholder="Select FPOD Location"
                              v-model="finalDeliveryModel.FpodLocationId"
                            ></model-list-select>
                            <span
                              class="error"
                              v-if="!finalDeliveryModel.FpodLocationId"
                            >{{FPODerrorList.FpodLocationId}}</span>
                          </md-layout>
                        </md-layout>

                        <md-layout md-gutter class="labelMargtop">
                        
                          <md-layout md-flex="15">
                            <label>Final Delivery Date</label>
                            <date-picker
                            :format="selectDateFormat"
                              lang="en"
                              v-model="finalDeliveryModel.finalDeliveryDate"
                              id="date"
                            ></date-picker>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="15">
                            <label>Gate In Date</label>
                            <date-picker
                            :format="selectDateFormat"
                              lang="en"
                              v-model="finalDeliveryModel.gateInDate"
                              id="date"
                            ></date-picker>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="15">
                            <label>Gate Out Date</label>
                            <date-picker
                            :format="selectDateFormat"
                              lang="en"
                              v-model="finalDeliveryModel.gateOutDate"
                              id="date"
                            ></date-picker>
                          </md-layout>
                        </md-layout>

                        <md-layout md-gutter class="mrgtop-button gutr">
                          
                          <b-button
                          class="mt-3"
                            variant="primary"
                            id="addButtonLoader"
                            @click="addFpodTables"
                          >Save & Submit</b-button>
                          <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                        </md-layout>
                      </div>
                      <div class="mt-3" v-if="fpodTableArrayList.length>0">
                  
                          <h5 class="box-title">
                            <b-badge>FPOD Details</b-badge>
                          </h5>
                    

                        <!-- /.box-header -->
                        <div class="box-body">
                          <table id="tariff" class="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>Container No</th>
                                <th>POD Location</th>
                                <th>FPOD Location</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr></tr>
                              <tr v-for="(item,index) in fpodTableArrayList" :key="index">
                                <td>{{index+1}}</td>
                                <td
                                  @click="editFPODDetail(item)"
                                  class="showMoreData"
                                >{{item.containerNo}}</td>
                                <td>{{item.Pod}}</td>
                                <td>{{item.Fpod}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!-- /.box-body -->
                      </div>
                    </md-list>
                  </md-list-expand>
                </md-list-item>
              </md-list>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopSail"></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop11212"
      @close="onClose11212"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../helper/collection";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editFFExecutionId") != "" &&
      this.$sessionsStorage.get("editFFExecutionId") != undefined
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/sailFPOD");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {
    sailVModel: {
      handler: function(newVal, oldVal) {
        if (newVal.hasOwnProperty("ffExecutionContainerId")) {
          if (
            this.getContainerSail.length > 0 &&
            this.sailVModel.ffSailId == ""
          ) {
            let arrayFilter = this.getContainerSail.filter(x => {
              return (
                x.ffExecutionContainerId ==
                this.sailVModel.ffExecutionContainerId
              );
            });

            this.sailVModel.containerNo = arrayFilter[0].containerNo;
            this.transhipment.containerNo = arrayFilter[0].containerNo;
          } else {
            this.transhipment.containerNo = this.sailVModel.containerNo;
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      selectDateFormat,
      isLoading: false,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      autoClientName: {},
      sailVModel: {
        ffSailId: "",
        containerNo: "",
        ffExecutionContainerId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        sailTranshipmentId: "",
        shippingId: "",
        vesselLoadingDate: "",
        vesselName: "",
        deliveryPortArrDate: "",
        dateOfDeparture: "",
        rotationNo: "",
        voyageName: "",
        isBookingtranshipment: ""
      },

      removesailVModel: {
        containerNo: "",
        ffExecutionContainerId: "",
        ffSailId: ""
      },

      transhipment: {
        sailTranshipmentId: "",
        ffSailId: "",
        tentativePortId: "",
        tentativePortName: "",
        vesselName: "",
        containerNo: "",

        etaDate: "",

        etdDate: ""
      },
      handoverDate: "",
      finalDeliveryModel: {
        handoverGateOutValid: "",
        containerNo: "",
        ffExecutionContainerId: "",
        podLocationId: "",
        FpodLocationId: "",
        finalDeliveryDate: "",
        gateInDate: "",
        gateOutDate: "",
        fffpodContainerId: ""
      },
      removefinalDeliveryModel: {
        containerNo: "",
        ffExecutionContainerId: "",
        fffpodContainerId: ""
      },
      finalDeliveryMain: {
        fffpodId: "",

        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId")
      },
      transhipmentArray: [],
      fpodTableArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: ""
      },

      getCLientData: ["gfdg"],
      showSegmentArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New"
      },
      commodityListName: [],
      mainEntryData: [],
      visible: true,
      getContainerSail: [],
      getSailData: ["abc"],
      getlocationListData: ["agra"],
      FPODpickupLocation: ["agra"],
      PODlocationList: ["agra"],
      validate: true,
      bookingtranshipmentName: [
        {
          bookingtranshipmentVal: "yes",
          bookingtranshipmentText: "Yes"
        },
        {
          bookingtranshipmentVal: "no",
          bookingtranshipmentText: "No"
        }
      ],
      containerforFPODDetail: [],

      TranshiperrorList: {
        tentativePortId: "",
        etaDate: "",

        etdDate: ""
      },
      arrayError: [
        "Enter your tentative port Name",
        "Select ETA Date",
        "Select ETA time",
        "Select ETA Date",
        "Select ETD time"
      ],
      FPODerrorList: {
        containerNo: "",
        podLocationId: "",
        FpodLocationId: ""
      },
      FPODError: [
        "Select container No",
        "Select Place od delivery",
        "Select Final Place of delivery"
      ],
      SailError: ["Select Container Number", "Select Booking Transhipment"],
      SailerrorList: {
        containerNo: "",
        isBookingtranshipment: ""
      },
      atleastOneTentative: "",

      validateTrans: true,
      tentativeDetailArray: [],
      editIndex: "",
      viewAllSail: [],
      viewAllTentative: []
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    // validateDate() {
    //   if (this.finalDeliveryModel.gateOutDate != "") {
    //     var date = new Date(this.finalDeliveryModel.gateOutDate);
    //     let newDate = date.setDate(date.getDate() - 1);

    //     return this.formatDate(this.handoverDate) > this.formatDate(newDate)
    //       ? true
    //       : false;
    //   } else {
    //     return false;
    //   }
    // },
    fpodTableArrayList() {
      return this.fpodTableArray;
    },
    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    viewAllSailList() {
      return this.viewAllSail;
    },

    containerSailList() {
      return this.getContainerSail;
    },
    locationList() {
      return this.getlocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.sailVModel.uploadDriverDoc.split(",");
    },
    bookingtranshipmentList() {
      return this.bookingtranshipmentName;
    },

    containerNoFPODList() {
      return this.containerforFPODDetail;
    }
  },
  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");
      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },

    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function(error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    viewEdit(id, index) {
      if (id == "") {
        this.editIndex = index;
        Object.keys(this.transhipment).map(x => {
          this.transhipment[x] = this.tentativeDetailArray[index][x];
        });
      } else {
        let array = this.tentativeDetailArray.filter(x => {
          return x.sailTranshipmentId == id;
        });

        Object.keys(this.transhipment).map(x => {
          this.transhipment[x] = array[0][x];
        });
      }
    },
    validatetranshipment() {
      let validate_new = true;
      Object.keys(this.TranshiperrorList).map((x, index) => {
        if (this.transhipment[x] == "") {
          this.TranshiperrorList[x] = this.arrayError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    addTentativeDetail() {
      let array_new = this.getlocationListData;

      this.transhipment["ffExportFclId"] = this.$sessionsStorage.get(
        "editExportFCLId"
      );
      this.transhipment["ffExecutionId"] = this.$sessionsStorage.get(
        "editFFExecutionId"
      );

      var obj = {};
      this.validatetranshipment();

      if (this.sailVModel.ffSailId == "") {
        if (this.validateTrans != false) {
          let arrayPort = array_new.filter(x => {
            return x.pickupId == this.transhipment.tentativePortId;
          })[0];
          this.transhipment.tentativePortName = arrayPort.pickupLocation;

          $("#addButtonLoader222").css("display", "none");
          $("#loader222").css("display", "block");
          var obj1 = {};
          Object.keys(this.transhipment).map(x => {
            obj1[x] = this.transhipment[x];
            this.transhipment[x] = "";
          });
          Object.keys(this.TranshiperrorList).map(x => {
            this.TranshiperrorList[x] = "";
          });

          if (
            this.editIndex == "" &&
            (this.editIndex != "0" || this.editIndex != 0)
          ) {
            this.alert.content = "Data Added Successfully";

            this.tentativeDetailArray.push(obj1);
          } else {
            this.alert.content = "Data Updated Successfully";
            this.$refs["addPop"].open();
            this.tentativeDetailArray.splice(this.editIndex, 1);
            this.tentativeDetailArray.splice(this.editIndex, 0, obj1);
            this.editIndex = "";
          }
          setTimeout(function() {
            $("#addButtonLoader222").css("display", "block");
            $("#loader222").css("display", "none");
          }, 1000);
        }
      } else {
        this.transhipment["ffSailId"] = this.sailVModel.ffSailId;

        if (this.validateTrans != false) {
          let arrayPort = array_new.filter(x => {
            return x.pickupId == this.transhipment.tentativePortId;
          })[0];
          this.transhipment.tentativePortName = arrayPort.pickupLocation;

          $("#addButtonLoader222").css("display", "none");
          $("#loader222").css("display", "block");
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/addTranshipmentSail.php`,
            data: JSON.stringify(this.transhipment),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };

          axios(options)
            .then(result => {
              const { statusText, status, data } = result;
              if ( status == 200 && data) {
                if (data.msg == "Inserted Successfully") {
                  Object.keys(this.transhipment).map(x => {
                    obj[x] = this.transhipment[x];
                    this.transhipment[x] = "";
                  });
                  Object.keys(this.TranshiperrorList).map(x => {
                    this.TranshiperrorList[x] = "";
                  });
                  obj["sailTranshipmentId"] = data.sailTranshipmentId;

                  this.tentativeDetailArray.push(obj);

                  this.alert.content = "Data Added Successfully";

                  this.transhipment.containerNo = this.sailVModel.containerNo;
                } else {
                  Object.keys(this.transhipment).map(x => {
                    this.transhipment[x] = "";
                  });

                  this.transhipment.containerNo = this.sailVModel.containerNo;
                  Object.keys(this.TranshiperrorList).map(x => {
                    this.TranshiperrorList[x] = "";
                  });
                  this.alert.content = "Data Updated Successfully";
                  this.$refs["addPop"].open();
                }

                setTimeout(function() {
                  $("#addButtonLoader222").css("display", "block");
                  $("#loader222").css("display", "none");
                }, 1000);

                this.getData();
              }
            })
            .catch(error => {});
        }
      }
    },

    editFPODDetail(item) {
      Object.keys(this.finalDeliveryModel).map(x => {
        this.finalDeliveryModel[x] = item[x] || "";
      });
    },
    validateaddSail() {
      let validate_new = true;

      Object.keys(this.SailerrorList).map((x, index) => {
        if (this.sailVModel[x] == "") {
          this.SailerrorList[x] = this.SailError[index];
          validate_new = false;
        }
      });

      if (
        this.tentativeDetailArray.length == 0 &&
        this.sailVModel.isBookingtranshipment == "yes"
      ) {
        this.atleastOneTentative = "Select Atleast one Transhipment";
        validate_new = false;
      } else {
        this.atleastOneTentative;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addSail() {
      this.sailVModel["transhipment"] = this.tentativeDetailArray;

      this.validateaddSail();

      if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addSailDetail.php`,
          data: JSON.stringify(this.sailVModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }

              this.$refs["addPopSail"].open();

              this.getData();
              Object.keys(this.removesailVModel).map(x => {
                this.sailVModel[x] = "";
              });
              this.tentativeDetailArray = [];
            }
          })
          .catch(error => {});
      }
    },
    validateFPOD() {
      let validate_new = true;

      Object.keys(this.FPODerrorList).map((x, index) => {
        if (this.finalDeliveryModel[x] == "") {
          this.FPODerrorList[x] = this.FPODError[index];

          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addFpodTables() {
      if (this.finalDeliveryModel.gateOutDate != "") {
        let date1 = new Date(this.handoverDate);
        let date2 = new Date(this.finalDeliveryModel.gateOutDate);
        let res = Math.abs(date2 - date1) / 1000;
        let days = Math.floor(res / 86400);
        console.log(this.handoverDate);
        if (days <= 3) {
          this.finalDeliveryModel["validateHandoverGateOut"] = days;
        }
      }
      if (
        this.containerforFPODDetail.length > 0 &&
        this.finalDeliveryModel.fffpodContainerId == ""
      ) {
        let newArray = this.containerforFPODDetail.filter(x => {
          return (
            x.ffExecutionContainerId ==
            this.finalDeliveryModel.ffExecutionContainerId
          );
        });

        if (newArray.length > 0) {
          this.finalDeliveryModel.containerNo = newArray[0].containerNo;
        }
      }

      let new_data = {
        finalDeliveryMain: this.finalDeliveryMain,
        finalDeliveryModel: this.finalDeliveryModel
      };

      this.validateFPOD();

      if (this.validate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addFinalPlaceDelivery.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.finalDeliveryMain.fffpodId = data.fffpodId;

              if (this.finalDeliveryModel.fffpodContainerId != "") {
                this.alert.content = " Data Updated Succesfully";
              } else {
                this.alert.content = " Data Added Succesfully";
              }

              Object.keys(this.finalDeliveryModel).map(x => {
                this.finalDeliveryModel[x] = "";
              });
              Object.keys(this.FPODError).map(x => {
                this.FPODError[x] = "";
              });

              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    viewEditSail(item) {
      Object.keys(this.sailVModel).map(x => {
        this.sailVModel[x] = item[x];
      });

      let array = this.viewAllTentative.filter(x => {
        return x.ffSailId == item.ffSailId;
      });
      this.tentativeDetailArray = array;
    },
    getPortId1(item) {
      this.sailVModel.toportId = item.portId;
    },
    getPortId2(item) {
      this.sailVModel.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    clientFilter(list, query) {
      return this.getCLientData.filter(x => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter(x => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    valis() {
      let validate_new = true;

      Object.keys(this.FPODerrorList).map((x, index) => {
        if (this.finalDeliveryModel[x] == "") {
          this.FPODerrorList[x] = this.FPODError[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    onClose11212() {},

    getData() {
      this.doLoading();
      let vehicle_drive = {
        itemCode: "itemCode",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToffSail.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            this.getCLientData = data.clientdetail;
            this.getlocationListData = data.LocationDetails;
            //this.finalDeliveryModel.podLocationId=
            // this.PODlocationList = data.LocationDetails;
            this.mainEntryData = data.FullfclDetails;
            let array1 = data.LocationDetails.filter(x => {
              return x.pickupId == data.FullfclDetails[0].finalPlaceLocationId;
            });

            // this.FPODpickupLocation = data.LocationDetails;
            this.FPODpickupLocation = array1;
            this.finalDeliveryModel.FpodLocationId = array1[0].pickupId;

            let array2 = data.LocationDetails.filter(x => {
              return x.pickupId == data.FullfclDetails[0].PODLocationId;
            });
            this.PODlocationList = array2;
            this.finalDeliveryModel.podLocationId = array2[0].pickupId;

            if (data.sailContainerDetail.length > 0) {
              this.getContainerSail = data.sailContainerDetail;
            } else {
              this.getContainerSail = [];
            }

            if (data.viewEditSailDetails.length > 0) {
              this.viewAllSail = data.viewEditSailDetails;
            }

            if (data.viewAllSailTrans.length > 0) {
              this.viewAllTentative = data.viewAllSailTrans;
            }

            if (data.containerforFPODDetail.length > 0) {
              this.containerforFPODDetail = data.containerforFPODDetail;
            } else {
              this.containerforFPODDetail = [];
            }

            if (data.FPODDetail.length > 0) {
              Object.keys(data.FPODDetail[0]).map(x => {
                this.finalDeliveryMain[x] = data.FPODDetail[0][x] || "";
              });
            }

            if (data.FPODDetailContainer.length > 0) {
              this.fpodTableArray = data.FPODDetailContainer;

              Object.keys(this.finalDeliveryModel).map(x => {
                this.finalDeliveryModel[x] =
                  data.FPODDetailContainer[0][x] || "";
              });
              Object.keys(this.removefinalDeliveryModel).map(x => {
                this.finalDeliveryModel[x] = "";
              });
            }

            if (this.sailVModel.ffSailId != "") {
              let array = this.viewAllTentative.filter(x => {
                return x.ffSailId == this.sailVModel.ffSailId;
              });
              this.tentativeDetailArray = array;
            }
            if (data.HandoverDetails.length > 0) {
              this.handoverDate = data.HandoverDetails[0].handoverDate;
            }
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },

    onClose22() {},

    previousPage() {
window.history.go(-1)
      // this.$router.push({
      //   path: "/freightForward/handoverToRail"
      // });
    }
  }
};
</script>
<style scoped>
.md-direction-bottom-right {
  width: 18% !important;
}
.md-sidenav .md-sidenav-content:hover {
  width: 100% !important;
  /* transition: 0.3s; */
}
.md-list .md-theme-default:hover {
  width: 100% !important;
}
.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-list-item-expand.md-active {
  position: relative;
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// sailFPOD.vue?5b442678